module.exports = __webpack_public_path__ + "assets/img/title-3658a806.png";